import { getApiBaseUrl } from '../config/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const VAPID_PUBLIC_KEY = 'BNpDZ-19oew-FlWhsma2DI3ne2imXQ_kaklVh8DzTTEt6y7rgNVwM1iyOduHSxJIA5PGvMBQ9YfvtdgMzEdwWxQ';

function getUserId() {
  try {
    const user = localStorage.getItem('authUser');
    if (user) return JSON.parse(user).id;
  } catch { /* ignore */ }
  return null;
}

/**
 * Subscribe to push notifications (ไม่ขอ permission เอง)
 * ใช้ได้เฉพาะเมื่อ permission === 'granted' แล้วเท่านั้น
 * เหมาะสำหรับเรียกตอน app reopen / re-subscribe
 */
export async function subscribePushNotifications(userId) {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
    if (!('Notification' in window) || Notification.permission !== 'granted') return false;

    const uid = userId || getUserId();
    if (!uid) return false;

    const registration = await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    const apiBaseUrl = getApiBaseUrl();
    const response = await fetch(`${apiBaseUrl.replace(/\/api$/, '')}/api/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: uid, subscription: subscription.toJSON() }),
    });

    if (!response.ok) {
      console.error('[Push] Server rejected subscription:', response.status);
      return false;
    }

    console.log('[Push] Subscribed successfully for user', uid);
    return true;
  } catch (error) {
    console.error('[Push] Subscribe failed:', error);
    return false;
  }
}

/**
 * ขอ permission + subscribe push ในขั้นตอนเดียว
 * ต้องเรียกจาก user gesture (กดปุ่ม) บนมือถือถึงจะทำงาน
 * เหมาะสำหรับเรียกจากปุ่ม "เปิดการแจ้งเตือน"
 */
export async function requestPermissionAndSubscribe(userId) {
  try {
    if (!('Notification' in window)) return false;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return false;

    return await subscribePushNotifications(userId);
  } catch (error) {
    console.error('[Push] Permission + subscribe failed:', error);
    return false;
  }
}
